import React, {  useContext, useEffect, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

export default function ConfModal({Title  ,open ,closeModal ,children})
{
    return <>
            <Dialog
            sx={{ '& .MuiDialog-paper': { width: '90vw' } }}
            maxWidth='lg'
            open={open}
            onClose={closeModal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {Title}
            </DialogTitle>
            <DialogContent>
                {children}
            </DialogContent>
            <DialogActions>
                <Button onClick={closeModal}>Cancel</Button>
            </DialogActions>
        </Dialog>
    </>
}
